<template>
  <div class="course">
    <div class="Tit">线上课程</div>
    <ul class="trainingContent">
      <li v-for="(item,index) in info.data" :key="index">
        <div class="time">
          <div class="t">
            <p>{{item.day_time.substring(0,4)}}年</p>
            <p>{{item.day_time.substring(5,7)}}月{{item.day_time.substring(7,10)}}日</p>
          </div>
          <div class="line"></div>
          <div class="garden"></div>
        </div>
        <div class="content">
          <ul class="ul">
            <div v-for="(items,indexs) in item.course" :key="indexs" class="learning">
              <div class="img fl"><img :src="items.cover" width="235" height="150" alt=""></div>
              <div class="h5 line-clamp-1 fr">{{items.title}}</div>
              <div class="allTime fr">
                <span class="already">{{items.rate}}</span>
                <span>{{items.study_time}}</span>
              </div>
              <div class="button fr">
                <span>笔记{{items.notes_num}}&nbsp;&nbsp;&nbsp;&nbsp;问答{{items.interlocution}}</span>
                <div v-if="items.is_completion === 1" class="jx fr">
                  <router-link tag="span" :to="{ path: '/CourseDetails', query: { id: items.id }  }">
                    继续学习
                  </router-link>
                </div>
                <div v-if="items.is_completion === 2" class="wc fr">已完成</div>
              </div>
            </div>
          </ul>
        </div>
      </li>
    </ul>

    <div style="clear: both;"></div>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :total="info.count">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        info: {},
        page: 1
      }
    },
    created () {
      this.getList()
    },
    methods: {
      pageChange (page) {
        this.page = page
        this.getList()
      },
      getList () {
        this.$http.post('/apipx/Personal/openrecord', {
          p: this.page,
          row: 10,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .course {
    .Tit {
      width: 890px;
      height: 69px;
      line-height: 69px;
      font-size: 24px;
      border-bottom: 1px solid #ebebeb;
      font-weight: bold;
    }

    .trainingContent {
      margin: 40px 0;

      li {
        display: flex;
        overflow: hidden;

        .time {
          width: 104px;
          min-height: 100%;
          display: inline-block;
          position: relative;

          .t {
            width: 70px;
            color: #b1b1b1;
            text-align: center;
          }

          .line {
            width: 1px;
            height: 100%;
            background-color: #b1b1b1;
            position: absolute;
            left: 79px;
            top: 0;
          }

          .garden {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #b1b1b1;
            position: absolute;
            left: 74px;
            top: 0px;
          }
        }

        ul {
          overflow: hidden;
          border-bottom: 1px solid #b1b1b1;
          padding-bottom: 34px;
        }

        .content {
          overflow: hidden;
          width: 786px;
          display: inline-block;

          .learning {
            height: 150px;
            width: 786px;
            margin: 34px auto 0;

            .img {
              width: 235px;
              height: 150px;
              border-radius: 5px;
            }

            .h5 {
              font-size: 18px;
              font-weight: bold;
              width: 531px;
              margin: 20px 0 0 0;
            }

            .allTime {
              width: 531px;
              color: #999999;
              height: 18px;
              line-height: 18px;
              margin: 20px 0 0 0;

              .already {
                display: block;
                float: left;
                width: 80px;
                margin: 0 30px 0 0;
                border-right: 1px solid #b1b1b1;
                color: #ff827b;
              }
            }

            .button {
              width: 531px;
              height: 50px;
              line-height: 50px;
              color: #999999;
              margin: 20px 0 0 0;

              .fr {
                width: 140px;
                text-align: center;
                height: 50px;
                border-radius: 25px;
                color: #fff;
                cursor: pointer;
                font-size: 16px;

                &.jx {
                  background-color: #ff827b;
                }

                &.wc {
                  background-color: #dadada;
                }
              }
            }
          }
        }
      }
    }

    .page {
      height: 35px;
      margin: 50px auto 0;

      .el-pagination {
        width: 500px;
        margin: 0 auto;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        border-radius: 50%;
        min-width: 33px;
        min-height: 33px;
        line-height: 33px;
        margin: 0 8px;

        &:hover {
          color: #ff8484;
        }
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ff8484;
        color: #FFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/course/course.vue